// extracted by mini-css-extract-plugin
module.exports = {"btnWrap":"index_btnWrap__pDDUC","icon":"index_icon___adOr","text":"index_text__Ab_Co","onlyIcon":"index_onlyIcon__hwoR5"};